export default "__VITE_ASSET__DLI3N0iz__"